import React, { Component } from 'react';
import { Button, DialogContainer, TextField } from 'react-md';
import { NotificationManager } from 'react-notifications';
import 'react-notifications/lib/notifications.css';
import ApiRequestService from '../component/ApiRequestService';
import restoreQuestionBankHandler from '../component/ArchiveRestoreAPI';
import LoadingSpinner from '../component/LoadingSpinner';
import TableRow from '../component/TableRow';
import '../css/mediaCss.css';
import questionListStyles from '../css/questionListStyles.css .js';
import styles from '../css/styles.css.js';
import UserAccessDetails from '../lib/UserAccessDetails';
import CreateQuestion from './CreateQuestion';
import LivePreview from '../component/LivePreview';
import CreateQuestions from "../pages/CreateQuestion";
import { AppSetting, AppProperties, ADMIN_USER_ROLE } from '../common/function';
import { browserHistory } from 'react-router';
import { CSVLink } from "react-csv";
import { BeatLoader } from 'react-spinners';
import moment from 'moment';
import ColumnHeader from '../component/ColumnHeader.js';
import DuplicateQuestionAndLink from '../component/custom/DuplicateQuestionAndLink';
import { Checkbox } from '@mui/material';
import BulkDuplicateDialog from '../component/BulkDuplicateDialog';
import SFConfirmAlert from '../component/custom/SFConfirmAlert.jsx';
import { confirmAlert } from 'react-confirm-alert';
import "../css/custom.css";



let question = {
  question_name: '',
  question_id: '',
  subject_id: 0,
  topic_id: 0,
  category_id: 0,
  subcategory_id: 0
};

export default class QuestionList extends Component {
  userAccessDetails = new UserAccessDetails();
  AppSetting = AppSetting();
  appProperties = AppProperties();
  baseFolder = this.appProperties.baseFolder;
  constructor(props) {
    super(props);
    this.state = {
      questions: [],
      lastComputedAt: null,

      temp_question: question,
      temp_id: '',
      addMode: true,
      categoryDiv: true,
      questionsDiv: false,
      explanationDiv: false,
      visible: false,
      visibleAddQuestion: false,
      questionName: '',
      selectedSubjectId: 0,
      selectedTopicId: 0,
      selectedCategoryId: 0,
      selectedSubCategoryId: 0,
      selectedQuestionId: 0,
      responseQuestions: [],
      selectedIndex: 0,
      loading: true,
      calculationLoading: false,
      copyMode: 0,
      moveMode : 0,
      errorMessage: '',
      errorType: '',
      saveOrderShow:false,
      readOnly:this.props.archive_mode,
      archive_id:parseInt(this.props.archive_id,10),
      archive_mode:this.props.archive_mode,
      instructor_name:  window.localStorage.getItem(`${this.AppSetting.REACT_APP_UNIVERSITY_SUFFIX}_OSUID`),
      userprofilerole : parseInt(window.localStorage.getItem(`${this.AppSetting.REACT_APP_UNIVERSITY_SUFFIX}_role`), 10),
      instSubjects:[],
      currSubject:false,
      addButtonVisibility:this.props.plusButton,
      PreviewQuestion: false,
      selectedRowIndex: -1,
      topicIdParams:0,
      subjectIdParams:0,
      categoryIdParams:0,
      subCategoryIdParams:0,
      questionIDParams: 0, 
      topicName: '',
      subjectName: '',
      categoryName: '',
      subCategoryName: '',
      visitedQuestion: false,
      duplicateLinkDialogOpen: false,
      duplicateLinkQuestionData: null,
      bulkDuplicateDialogVisible: false,
      duplicateQuestions: [],
      isSingleDuplication: false,
      confirmDeleteObj: null,
      _userAccessDetails: JSON.parse(window.localStorage.getItem(`${this.AppSetting.REACT_APP_UNIVERSITY_SUFFIX}_userAccessDetails`)),
    };
    this.changeQuestionName = this.changeQuestionName.bind(this);
    this.addQuestion = this.addQuestion.bind(this);
    this.isEnterPressed = this.isEnterPressed.bind(this);    
    this.questionOrderUpdate = this.questionOrderUpdate.bind(this);
    this.saveQuestionOrder = this.saveQuestionOrder.bind(this);
    //this.errorMessageHide= this.errorMessageHide.bind(this);
    this._refresh = this._refresh.bind(this);
    this.hidePreviewQuestion = this.hidePreviewQuestion.bind(this);
    this.onMouseOverPreview = this.onMouseOverPreview.bind(this);
  }

  componentWillMount() {
    if(this.props.location !== undefined 
      && this.props.location !== null
      && this.props.location.query !== undefined 
      && this.props.location.query !== null 
      ) {
        this.state.topicIdParams = parseInt(this.props.location.query.topic_id, 10);
        this.state.subjectIdParams =  parseInt(this.props.location.query.subject_id, 10);
        this.state.categoryIdParams= parseInt(this.props.location.query.category_id, 10);
        this.state.subjectName = this.props.location.query.subject_name;
        this.state.topicName = this.props.location.query.topic_name;
        this.state.categoryName = this.props.location.query.category_name;
        if(this.props.location.query.question_id && this.state.visitedQuestion == false){
          this.state.questionIDParams = parseInt(this.props.location.query.question_id, 10);
        }
        if(this.props.location.query.subcategory_id !== undefined 
          && this.props.location.query.subcategory_id !== null
          && this.props.location.query.subcategory_name !== undefined
          && this.props.location.query.subcategory_name !== null
          ) {
            this.state.subCategoryIdParams = parseInt(this.props.location.query.subcategory_id, 10);
            this.state.subCategoryName = this.props.location.query.subcategory_name;

          }
      }
    this._refresh();
  }

  componentDidMount() {
    if (this.props.updateLoading) {
      this.props.updateLoading(true);
    }
  }

  componentDidUpdate() {
    // refresh the page if url changed
    if(this.props.subject_id !== undefined && this.props.subject_id !== null &&
      this.props.topic_id !== undefined && this.props.topic_id  !== null &&
      this.props.category_id !== undefined && this.props.category_id  !== null &&
      this.props.subcategory_id !== undefined && this.props.subcategory_id  !== null 
      
      ) {

        let paramsSubjectId = this.props.location.query.subject_id
        let paramsTopicId = this.props.location.query.topic_id
        let paramscategoryId = this.props.location.query.category_id
        let paramsSubCategoryId = this.props.location.query.subcategory_id
        let paramsQuestionId  = this.props.location.query.question_id

        if (this.props.subject_id !== paramsSubjectId  || 
          this.props.topic_id !== paramsTopicId ||
          this.props.category_id !== paramscategoryId ||
          this.props.subcategory_id !== paramsSubCategoryId
          ) {
          this.state.topicIdParams = parseInt(paramsTopicId, 10)
          this.state.subjectIdParams =  parseInt(paramsSubjectId, 10)
          this.state.categoryIdParams= parseInt(paramscategoryId, 10)
          this.state.subCategoryIdParams =parseInt(paramsSubCategoryId, 10)
          this.state.questionIDParams = parseInt(paramsQuestionId,10)
          this.state.subjectName = this.props.location.query.subject_name
          this.state.topicName = this.props.location.query.topic_name
          this.state.categoryName = this.props.location.query.category_name
          this.state.subCategoryName = this.props.location.query.subcategory_name
          this.setState({ 
            visitedQuestion : false
          });
            this._refresh();
          }
    }
  }

  

  _refresh(){
    this.setState({ loading: true });
    var sub_id = parseInt(this.props.subject_id, 10);
    var top_id = parseInt(this.props.topic_id, 10);
    var catg_id = parseInt(this.props.category_id, 10);
    var subcatg_id = parseInt(this.props.subcategory_id, 10);

    let payload = {
      subject_id: sub_id,
      topic_id: top_id,
      category_id: catg_id,
      subcategory_id: subcatg_id,
      should_calculate: false,
    };
    if(this.state.archive_mode === 'true'){
      payload['archive_id'] = this.state.archive_id;
      payload['archive_mode'] = true;
    }

    // Use cached instructor subjects from localStorage instead of API call
    let subjectsByIns = this.state._userAccessDetails?.subjectsbyInstructor || {};
    let currSubject = subjectsByIns[sub_id] === true;

    ApiRequestService({
      method: 'post',
      url: '/getAllQuestions',
      data: payload
    }).then(res => {
      console.debug('res.data.data.questions =', res);
      if (this.props.updateLoading) {
        this.props.updateLoading(false);
      }

      this.props.updateTotalCount(res.data.data?.subcategory_explanation_count, res.data.data?.subcategory_tutorial_count)

      if (res.data.data.questions != null) {
        let questionsList =res.data.data.questions;

         this.props.number_of_question(questionsList.length)

          this.setState({
            questions: questionsList,
            instSubjects : subjectsByIns,
            currSubject:currSubject,
            loading: false,
            lastComputedAt: res.data.data.last_computed_at?.includes("1970") ? null : res.data.data.last_computed_at,
          });
        }else{
          this.setState({
            instSubjects : subjectsByIns,
            currSubject:currSubject,
            loading: false,
            lastComputedAt: null
          });
        }
    }).catch(err =>{
      this.setState({ loading: false });
      this.hide();
      NotificationManager.error(err, 'ERROR', 3000);
    });
  }

  handleDuplicateQuestionLink = (id, isCopyMode, isMoveMode,qid) => {
    if (id !== -1) {
      this.setState({
        duplicateLinkDialogOpen: true,
        duplicateLinkQuestionData: this.state.questions[id],
      });
    }
  }

  handleDuplicateLinkDialogClose = (refreshList) => {
    this.setState({
      duplicateLinkDialogOpen: false,
      duplicateLinkQuestionData: null,
    });
    if (refreshList) {
      this._refresh();
    }
  }

  show = (id, isCopyMode, isMoveMode,qid) => {
    this.routerPush(qid)
    console.debug('Show Called', isCopyMode);
    console.debug('this.state.questions[id]', this.state.questions);

    console.log(this.state+" - ID "+id);
    var tempSelectedSubjectId;
    var tempSelectedTopicId;
    var tempSelectedCategoryId;
    var tempSelectedSubCategoryId;
    var tempSelectedQuestionId;
    if (id === -1) {
      tempSelectedSubjectId = parseInt(this.props.location.query.subject_id, 10);
      tempSelectedTopicId = parseInt(this.props.location.query.topic_id, 10);
      tempSelectedCategoryId = parseInt(this.props.location.query.category_id, 10);
      tempSelectedSubCategoryId = parseInt(this.props.location.query.subcategory_id, 10);
      tempSelectedQuestionId = -1;
    } else {
      tempSelectedSubjectId = parseInt(
        this.state.questions[id].subject_id,
        10
      );
      tempSelectedTopicId = parseInt(this.state.questions[id].topic_id, 10);
      tempSelectedCategoryId = parseInt(
        this.state.questions[id].category_id,
        10
      );
      tempSelectedSubCategoryId = parseInt(
        this.state.questions[id].subcategory_id,
        10
      );
      tempSelectedQuestionId = parseInt(
        this.state.questions[id].question_id,
        10
      );
    }

    console.debug(
      'edit  Question i:' + id + ' id: ' + tempSelectedQuestionId
    );
    console.debug('edit  subject_id i:' + id + ' id: ' + tempSelectedSubjectId);
    console.debug('edit  topic_id i:' + id + ' id: ' + tempSelectedTopicId);
    console.debug('edit  cat i:' + id + ' id: ' + tempSelectedCategoryId);
    console.debug(
      'edit  subcategory_id i:' + id + ' id: ' + tempSelectedSubCategoryId
    );

    this.setState({
      selectedSubjectId: tempSelectedSubjectId,
      selectedTopicId: tempSelectedTopicId,
      selectedCategoryId: tempSelectedCategoryId,
      selectedSubCategoryId: tempSelectedSubCategoryId,
      selectedQuestionId: tempSelectedQuestionId,
      visible: true,
      selectedIndex: id,
      copyMode: isCopyMode,
      moveMode: isMoveMode
    });
    
    //this.setState({ visible: true });
  };

  hide = (res, index) => {
    if(this.state.questionIDParams){
      this.state.questionIDParams=0;
      this.state.visitedQuestion=true;
    }
    this.routerPush(0)
    console.debug('response question close= ', res);
    if (this.state.copyMode === 1 && this.redirectURL !== undefined) {
      NotificationManager.info(
        'Duplication Successful!',
        '',
        3000
      );
      //window.location = this.redirectURL;
    }
    var tempQuestionArrList = this.state.questions;
    if (res !== undefined && res.data !== undefined) {
      if (res.data.data.question_name !== undefined) {
        console.debug('response question close= ', index);
        console.debug('question array = ', this.state.questions);
        // var tempQuestionArrList = this.state.questions;

        if (
          tempQuestionArrList[index].question_name !==
          res.data.data.question_name
        ) {
          tempQuestionArrList[index].question_name =
            res.data.data.question_name;
        }
      }
    }

    this.setState({
      visible: false,
      renderNode: null,
      questions: tempQuestionArrList
    });
    this._refresh();
  };

  routerPush(ID) {
    // console.log("routerPush ")
    let url =
        "SubCategoryDetails"+
        "?topic_id=" +
        this.state.topicIdParams +
        "&subject_id=" +
        this.state.subjectIdParams +
        "&category_id=" +
        this.state.categoryIdParams +
        "&subject_name=" +
        this.state.subjectName +
        "&topic_name=" +
        this.state.topicName +
        "&category_name=" +
        this.state.categoryName +
        "&archive_mode=" +
        this.state.archive_mode +
        "&archive_id=" +
        this.state.archive_id ;
      if (ID !== undefined && ID !== null && ID !== 0) {
        url = url + "&question_id=" + ID;
      }  
      if (
        this.state.subCategoryIdParams !== undefined &&
        this.state.subCategoryIdParams !== null &&
        this.state.subCategoryIdParams !== 0 &&
        this.state.subCategoryName !== undefined &&
        this.state.subCategoryName !== null &&
        this.state.subCategoryName !== 0
      ) {
        url =
          url +
          "&subcategory_id=" +
          this.state.subCategoryIdParams +
          "&subcategory_name=" +
          this.state.subCategoryName;
      }
    // console.log("url---------------",baseFolder + url)
    browserHistory.push(this.baseFolder + url);
  }
  addQuestion() {
    /*141 Subject, Topic, Cat, Sub Cat Names should not allow empty or empty space*/
    if (
      this.state.questionName === null ||
      this.state.questionName.trim() === ''
    ) {
      alert('Please enter a valid "Question Name"');
      return;
    }
    this.setState({ loading: true });
    console.debug('Add Question ');
    var sub_id = parseInt(this.props.subject_id, 10);
    var top_id = parseInt(this.props.topic_id, 10);
    var cat_id = parseInt(this.props.category_id, 10);
    var subcat_id = parseInt(this.props.subcategory_id, 10);

    var questionName = this.state.questionName.trim();
    // if(questionName != null && questionName != ""){
    //    alert("Please enter question name.");
    //     return
    // }

    const payload = {
      subject_id: sub_id,
      topic_id: top_id,
      category_id: cat_id,
      subcategory_id: subcat_id,
      question_name: questionName
    };
    ApiRequestService({
      method: 'post',
      url: '/addQuestions',
      data: payload
    }).then(res => {
      console.debug('Add question response', res);

      var tempQuestions = this.state.questions.slice();

      if (res.data.message !== null && res.data.message !== '') {
        // Bug id #143 fixed
        this.setState({ loading: false });
        this.addQuestionHide();
        NotificationManager.error(res.data.message, 'ERROR', 3000);
        return;
      }

      if (res.data.data != null) {
        if (res.data.data.question_name != null) {
          tempQuestions.push({
            question_name: res.data.data.question_name.trim(),
            question_id: res.data.data.question_id,
            subject_id: res.data.data.subject_id,
            topic_id: res.data.data.topic_id,
            category_id: res.data.data.category_id,
            subcategory_id: res.data.data.subcategory_id
          });

          this.setState({
            questions: tempQuestions,
            loading: false
          },()=>{
            //After Creating Question Page, take the User to Create Question Directly.
            this.show(this.state.questions.length-1,false,false,0);
          });


        }
      }
      console.debug('this.state.questions', this.state.questions);
      this.setState({
        loading: false
      });
    });

    this.addQuestionHide();
  }

  

  delete = id => {

    let questionData = this.state.questions[id];
    if (questionData && questionData.child_linked_question_keys != "" && questionData.child_linked_question_keys.length > 0) {
      NotificationManager.error("This question is currently linked to other subcategories. Please remove the links before deleting it.", "", 5000);
      return;
    }

    //bug id 167 fixes
    confirmAlert({
      title: 'Do you really want to delete this question?',
      message: 'Press Confirm to submit',

      cancelLabel: 'Confirm',
      confirmLabel: 'Cancel',
      onCancel: () => this.deleteQuestion(id)
    });
  };

  deleteQuestion(id) {
    this.setState({ loading: true });
    console.debug(
      'Deleting Question i:' +
        id +
        ' id: ' +
        this.state.questions[id].question_id
    );
    var sub_id = parseInt(this.props.subject_id, 10);
    var top_id = parseInt(this.props.topic_id, 10);
    var cat_id = parseInt(this.props.category_id, 10);
    var subcat_id = parseInt(this.props.subcategory_id, 10);
    var questionId = parseInt(this.state.questions[id].question_id, 10);
    const payload = {
      subject_id: sub_id,
      topic_id: top_id,
      category_id: cat_id,
      subcategory_id: subcat_id,
      question_id: questionId,
      archive_mode:this.state.archive_mode
    };
    ApiRequestService({
      method: 'post',
      url: '/deleteQuestions',
      data: payload
    })
      .then(res => {
        console.debug('delete question response', res);
        this.state.questions.splice(id, 1);
        this.setState({
          questions: this.state.questions,
          loading: false,
          confirmDeleteObj: null,
        });
        console.debug('Spliced Array', this.state.questions);
      })
      .catch(error => {
        //bug-tracker#162

        console.error('Error When Deleting ', error);
        if (error.status !== undefined && error.status === 403) {
          //User Doesnt Have Access
          NotificationManager.error(
            'Unauthorized',
            'You are not authorized to delete question',
            5000
          );
        }
        this.setState({
          loading: false,
          confirmDeleteObj: null,
        });
      });
  }

  changeQuestionName(e) {
    var tempQuestionName = e;
    this.setState({
      questionName: tempQuestionName
    });
    console.debug('questionName = ', this.state.questionName);
  }

  addQuestionShow = () => {
    //this.errorMessageHide();
    this.show(-1, 0,0, -1);
    // this.setState({ visibleAddQuestion: true });
  };

  calculateAccuracyAndTime = () => {

    var sub_id = parseInt(this.props.subject_id, 10);
    var top_id = parseInt(this.props.topic_id, 10);
    var cat_id = parseInt(this.props.category_id, 10);
    var subcat_id = parseInt(this.props.subcategory_id, 10);
    let payload = {
      subject_id: sub_id,
      topic_id: top_id,
      category_id: cat_id,
      subcategory_id: subcat_id,
      type: "Question"
    }
    this.setState({ calculationLoading: true });
    ApiRequestService({
      method: 'post',
      url: '/calculateAccuracyAndTime',
      data: payload
    }).then(res => {
        if (res && res.data && res.data.status === 0) {
          let accuracyTimeArr = res.data.data.accuracy_time_arr;
          let updatedQuestions = this.state.questions.map(question => {
            let accuracyTimeData = accuracyTimeArr.find(acc => {
              return acc.subject_id === question.subject_id &&
              acc.topic_id === question.topic_id &&
              acc.category_id === question.category_id &&
              acc.subcategory_id === question.subcategory_id &&
              acc.question_id === question.question_id
            })
            if (accuracyTimeData) {
              return {
                ...question,
                avg_time: accuracyTimeData.time,
                difficulty_level: accuracyTimeData.accuracy
              }
            }
            return question;
          });
          this.setState({
            questions: updatedQuestions,
            lastComputedAt: new Date(),
          })

          NotificationManager.success("Calculation of accuracy and time completed successfully!", "", 3000);
        } else {
          NotificationManager.error("Something went wrong", "", 3000);
        }
      }).finally(() => {
        this.setState({ calculationLoading: false });
      });
  }

  addQuestionHide = () => {
    this.setState({
      visibleAddQuestion: false,
      addMode: true
    });
  };
  questionUpdateResponse(response) {
    console.debug('response', response);
    //responseQuestions
  }

  //bug-tracker#69
  setRedirectURL(url) {
    this.redirectURL = url;
  }
  questionOrderOnMoveUp(index, isGoingUp, thisObj) {
    console.debug('moveRow index =', index);
    console.debug('moveRow isGoingUp = ', isGoingUp);
    console.debug('moveRow thisObj = ', thisObj);

    var tempQuestionsArr =  this.state.questions;

    this.questionOrderUpdate(index,tempQuestionsArr,thisObj,isGoingUp);

    


  }

  questionOrderOnMoveDown(index, isGoingUp, thisObj) {
    console.debug('moveRow index 1', index);
    console.debug('moveRow isGoingUp 1 ', isGoingUp);
    console.debug('moveRow thisObj 1', thisObj);
    var tempQuestionsArr =  this.state.questions;

    this.questionOrderUpdate(index,tempQuestionsArr,thisObj,isGoingUp)

  }

  questionOrderUpdate(swipeIndex,tempQuestionsArr,thisObj,isGoingUp){

    this.setState({saveOrderShow:true});
    console.debug('swipeIndex = ', swipeIndex);

      var i = swipeIndex;
      var j = 0;
      var dontSwap = true;
      if (isGoingUp === true) {
        console.debug('swipeIndex = ', swipeIndex);
        if (swipeIndex !== -1) {
          j = i - 1;
          if (j === -1) {
           dontSwap = true;
          }
          else{
            dontSwap = false;
          }
        }
      }else  if (isGoingUp === false) {
        if (swipeIndex !== -1) {
          j = i + 1;
          if (j >= tempQuestionsArr.length) {            
            dontSwap = true;
          }
          else{
            dontSwap = false;
          }
        }
      }

      if(dontSwap === false){
        var tempSwipeOrder = tempQuestionsArr[j];
        tempQuestionsArr[j] = tempQuestionsArr[i];
        tempQuestionsArr[i] = tempSwipeOrder;
        
        tempQuestionsArr[i].question_order = i+1;
        tempQuestionsArr[j].question_order = j+1	;
        

        console.debug('tempQuizInfoArr[j] = ', tempQuestionsArr[j].question_order);
        console.debug('tempQuizInfoArr[i] = ', tempQuestionsArr[i].question_order);            

      }

    
    console.debug('tempQuestionsArr = ', tempQuestionsArr);
    
    this.setState({ questions: tempQuestionsArr });

  }
  saveQuestionOrder(){
    this.setState({ loading: true });

    console.debug('saveQuestionOrder');

    const payload={
      "questions":this.state.questions
    }
    console.debug('saveQuestionOrder payload = ',payload);
    ApiRequestService({
      method: 'post',
      url: '/saveQuestionOrder',
      data: payload
    }).then(res => {
      this.setState({ loading: false });      
      if(res !== undefined && res !== null && res.data !== undefined && res.data !== null
        && res.data.data !== undefined && res.data.data !== null  &&
        res.data.data.message !== undefined &&  res.data.data.message !== ""){
        NotificationManager.error('Error '+res.data.data.message, 'ERROR', 3000);
      }else{
        NotificationManager.success(         
          'Question order is saved successfully!',
          'Saved!',
          3000
        );
        this.setState({ saveOrderShow: false });
        
      }
      
      
    })

  }
  
  isEnterPressed(event){
    var code = event.keyCode || event.which;
    if(code === 13) { //13 is the enter keycode
      this.addQuestion()
    } 
  }

  onPreviewQuestion(id){
    if(id === this.state.selectedRowIndex){
      this.setState({PreviewQuestion: false , selectedRowIndex: -1})
    }else{
      let questions = this.state.questions;
    
      var tempSelectedSubjectId = parseInt( questions[id].subject_id,10 );
      var tempSelectedTopicId = parseInt( questions[id].topic_id, 10);
      var tempSelectedCategoryId = parseInt( questions[id].category_id,10 );
      var tempSelectedSubCategoryId = parseInt( questions[id].subcategory_id,10 );
      var tempSelectedQuestionId = parseInt( questions[id].question_id,10 );
  
      this.setState({
        selectedSubjectId: tempSelectedSubjectId,
        selectedTopicId: tempSelectedTopicId,
        selectedCategoryId: tempSelectedCategoryId,
        selectedSubCategoryId: tempSelectedSubCategoryId,
        selectedQuestionId: tempSelectedQuestionId,
        PreviewQuestion: true,
        selectedRowIndex: id
      });
    }
  }

  onMouseOverPreview(id){
    if(this.state.selectedRowIndex >= 0){
      let questions = this.state.questions;
    
      var tempSelectedSubjectId = parseInt( questions[id].subject_id,10 );
      var tempSelectedTopicId = parseInt( questions[id].topic_id, 10);
      var tempSelectedCategoryId = parseInt( questions[id].category_id,10 );
      var tempSelectedSubCategoryId = parseInt( questions[id].subcategory_id,10 );
      var tempSelectedQuestionId = parseInt( questions[id].question_id,10 );
  
      this.setState({
        selectedSubjectId: tempSelectedSubjectId,
        selectedTopicId: tempSelectedTopicId,
        selectedCategoryId: tempSelectedCategoryId,
        selectedSubCategoryId: tempSelectedSubCategoryId,
        selectedQuestionId: tempSelectedQuestionId,
        PreviewQuestion: true,
        selectedRowIndex: id
      });
    }
    }
  

  hidePreviewQuestion(){
    this.setState({PreviewQuestion: false , selectedRowIndex: -1})
  }

  deleteSelectedQuestions = () => {
    let selectedQuestions = this.state.questions.filter(quest => quest.selected);
    this.setState({
      loading: true
    })
    ApiRequestService({
      method: 'post',
      url: '/bulkDeleteQuestions',
      data: selectedQuestions,
    }).then(res => {
      if (res?.data?.message === "") {
        let tempQuestions = this.state.questions.filter(quest => !quest.selected)
        this.setState({
          questions: tempQuestions,
        })
      } else {
        NotificationManager.error(res?.data?.message ?? "Something went wrong", "Error", 4000)
      }
    }).finally(() => {
      this.setState({
        loading: false,
        confirmDeleteObj: null,
      })
    })
  }

  render() {
    const { visible } = this.state;

    let button = null;

    button = (
      <Button style={styles.addButton} onClick={this.addQuestion}>
        Add Question
      </Button>
    );

    var cancelButton = (
      <Button style={styles.cancelButton} onClick={this.addQuestionHide}>
        Cancel
      </Button>
    );

    const actions = [];
    actions.push(button);
    actions.push(cancelButton);

    var tbody = null;
    if (this.state.questions != null) {
      tbody = (
        <tbody>
          {this.state.questions.map((Question, i) => (
            
            <TableRow  
              key={i}
              questionIndex={i}
              data={Question}
              pushId={'questions'}
              id={Question.question_id}
              name={Question.question_name}
              onDuplicateQuestionAndLinkClick={
                () => this.handleDuplicateQuestionLink(i, 1,0,0)
              }
              onCopyClick={() => this.setState({ bulkDuplicateDialogVisible: true, duplicateQuestions: [Question], isSingleDuplication: true })}
              onMoveClick={() => this.show(i, 1, 1,0)}
              onEditClick={() => {this.show(i, 0,0, Question.question_id)}}
              onDeleteClick={() => this.delete(i)}
              onViewClick={() => this.onPreviewQuestion(i)}
              onMoveOver={() => this.onMouseOverPreview(i)}
              order={Question.question_order}
              questionOrderOnMoveUp={() =>this.questionOrderOnMoveUp(i,true,Question.question_order)}
              questionOrderOnMoveDown={() =>this.questionOrderOnMoveDown(i,false,Question.question_order)}
              disable_orders={this.props.readOnly}
              show_archive_actions={this.state.archive_mode}
              instructorSubject={(this.state.instSubjects && this.state.instSubjects[Question.subject_id] === true) }
              onArchiveRestoreClick={()=>this.onArchiveRestoreClick(Question)}
              selectedRowIndex={this.state.selectedRowIndex}
              created_by={Question.created_by}
              onSelectQuestion={(checked) => {
                let tempQuestionsArr = [...this.state.questions];
                tempQuestionsArr[i] = { ...tempQuestionsArr[i], selected: checked };
                this.setState({ questions: tempQuestionsArr });
              }}
            />
          ))}
        </tbody>
      );
    }
    
    return (
      (this.state.loading) ?
        <LoadingSpinner loading={this.state.loading} />
     :
      <div style={{marginLeft:'50px'}}>
        {/*<Loader loading={this.state.loading} />*/}
      
        <div>{this.state.subject_name}</div>

        <div style={{float:'right', marginRight:'1rem', marginTop:"6px",}}>
            <CSVLink data={[
              ['ID', 'Name', ],
              ...this.state.questions?.map(ques => {
                return [
                  ques.question_id,
                  ques.question_name,
                ]
              })
            ]}  target='_blank' enclosingCharacter='"' filename={`Question list for ${this.state.subCategoryName} from ${this.state.categoryName} from ${this.state.topicName}.csv`}>
                <Button flat primary iconChildren="cloud_download">Download CSV</Button>
            </CSVLink>
          </div>

        <table style={styles.subCatTable}  className = {`tableStyle ${this.state.PreviewQuestion ? 'TableQuestionPreview' : ''}`}>
          <thead style={styles.thead}>
            <tr>
              
              {/* <th colSpan="12"> */}
              <th colSpan="12">
                {this.state.questions?.some(q => q.selected) ? 
                  <div style={{display:"flex", gap:'8px'}}>
                    <Button primary raised onClick={() => this.setState({ bulkDuplicateDialogVisible: true, duplicateQuestions: this.state.questions.filter(q => q.selected) })}>
                        Duplicate Selected
                    </Button>

                    <Button primary raised onClick={() => {
                      this.setState({
                          confirmDeleteObj: {
                              open: true,
                              title: "Delete Questions",
                              description:"Are you sure you want to delete selected questions?"
                          }
                      });
                    }}>
                        Delete Selected
                    </Button>
                  </div>
                : null
              }

              {
                this.props.readOnly
              ?
                null
              :
              <div style={this.state.currSubject ?  styles.floatRight : {display:"none"} }>
              {this.state.saveOrderShow === true && (!this.appProperties.enableLTI) ?
                <Button style={styles.addButton} onClick={this.saveQuestionOrder} >
                  Save Order
                </Button> :""}

                {
                   (!this.appProperties.enableLTI) ? 
                   <div style={{display:'flex', gap:'8px', marginBottom:'1rem'}}>
                      <div style={{display:'flex', flexDirection:'column'}}>
                        <Button 
                        style={{
                          display: this.state.userprofilerole === ADMIN_USER_ROLE ? 'block' : 'none'
                        }}
                        tooltipLabel={
                          <div>{this.state.lastComputedAt ? 
                            `Last computed at: ${moment(this.state.lastComputedAt).format('DD/MM/YYYY hh:mm a')}` : "N/A"}
                          </div>
                        }
                        primary flat onClick={this.calculateAccuracyAndTime}
                        disabled={this.state.calculationLoading}>
                          {this.state.calculationLoading ? <span>
                            <BeatLoader color={'#bb0000'} loading={true} size={10} />
                          </span> : "Calculate accuracy and time"}
                        </Button>
                        
                      </div>
                    <Button className="archive-button" primary raised
                  style={this.state.addButtonVisibility?{display:"none"}:{display:"block"}}
                  onClick={this.addQuestionShow}>
                  Add a New Question
                  </Button> 
                  </div>
                  : ""
                }
                
                </div>
              }
              </th>
            </tr>
            <tr>
              <th>
                <Checkbox
                  size='small'
                  style={{margin: 0, padding: 0}}
                  id='select-all-question-checkbox'
                  checked={this.state.questions?.length > 0 && this.state.questions.every(q => q.selected)}
                  indeterminate={this.state.questions?.some(q => q.selected) && !this.state.questions.every(q => q.selected)}
                  onChange={(_, checked) => {
                    let tempQuestionsArr = this.state.questions.map(quest => {
                      return {
                        ...quest,
                        selected: checked,
                      }
                    })
                    this.setState({
                      questions: tempQuestionsArr,
                    })
                  }}
                />
              </th>
              <th>ID</th>
              <th>Questions</th>
              
              {
                this.props.readOnly?
                null:
                <th>Order</th>
              }
              <th>Parent Question</th>
              <th>Linked Child Questions</th>
              <th><ColumnHeader title={"Accuracy"} tooltip={"Mean Accuracy"} /></th>
              <th><ColumnHeader title={"Time"} tooltip={"Median Time per question in seconds"} /></th>
              {
                this.props.readOnly || this.appProperties.enableLTI ?
                null:
                <th>Actions</th>
              }
            </tr>
          </thead>

          {tbody}
        
        </table> 

        
        <SFConfirmAlert 
          open={this.state.confirmDeleteObj?.open}
          title={this.state.confirmDeleteObj?.title}
          description={this.state.confirmDeleteObj?.description}
          onConfirm={() => {
            const deleteId = this.state.confirmDeleteObj?.deleteId;
            if (deleteId !== undefined && deleteId !== null) {
              this.deleteQuestion(deleteId);
            } else {
              this.deleteSelectedQuestions();
            }
          }}
          loading={this.state.loading}
          onCancel={() => {
              this.setState({
                  confirmDeleteObj: null
              });
          }}
        />

        {this.state.PreviewQuestion ?
        <div className="LivePreviewBlock tableStyle" >
          
              {/* <p style={styles.previewTitle}> Live Preview</p>
              <p style={{ float: 'right'}}>
                <Button className="exitButton" 
                flat
                primary
                swapTheming
                style={styles.buttomClass}
                onClick={this.hidePreviewQuestion}
                > Exit 
                </Button>

              </p> */}
              <CreateQuestions 
                key={this.state.selectedQuestionId} 
                selectedSubjectId={this.state.selectedSubjectId}
                selectedTopicId={this.state.selectedTopicId}
                selectedCategoryId={this.state.selectedCategoryId}
                selectedSubCategoryId={this.state.selectedSubCategoryId}
                selectedQuestionId={this.state.selectedQuestionId}
                hidePreviewQuestion = {this.hidePreviewQuestion}
                IsQuestionList={true}
              />
             
        </div > : ''
        }
        <div>
          <DialogContainer
            id="simple-action-dialog"
            visible={this.state.visibleAddQuestion}
            onHide={this.hide}
            actions={actions}
           // title="New Question Name"
            width="500px"
          >
          <p style={{fontSize:"medium"}}><b><label for="queId">New Question</label></b></p>
            <TextField
            id="queId"
              name="question_name"
              defaultValue=""
              onChange={this.changeQuestionName}
              style={questionListStyles.dialogText}
              onKeyPress={this.isEnterPressed.bind(this)}
            />
          </DialogContainer>
        </div>

        <DialogContainer
          id="navigation-drawer-demo"
          aria-label="Navigation Drawer Demo"
          visible={visible}
          fullPage
          focusOnMount={false}
          onShow={this.handleShow}
          onHide={this.hide}
          closeOnEsc={false}
        >
          <div>
            {' '}
            <Button icon onClick={this.hide}>
              close
            </Button>
          </div>
          <div style={{ overflow: 'hidden' }}>
            <CreateQuestion
              selectedSubjectId={this.state.selectedSubjectId}
              selectedTopicId={this.state.selectedTopicId}
              selectedCategoryId={this.state.selectedCategoryId}
              selectedSubCategoryId={this.state.selectedSubCategoryId}
              selectedQuestionId={this.state.selectedQuestionId}
              hidemodule={this.hide}
              selectedIndex={this.state.selectedIndex}
              copyMode={this.state.copyMode}
              moveMode={this.state.moveMode} //Adding Move Option
              setRedirectURL={this.setRedirectURL.bind(this)}
              close={this.hide}
              readOnly={this.props.readOnly}
              currSubject={this.state.currSubject}
            />
          </div>
          <br/>

          <div />
        </DialogContainer>
        {this.state.questionIDParams && !this.state.visitedQuestion ? 
        <div>
          <DialogContainer
          id="navigation-drawer-demo"
          aria-label="Navigation Drawer Demo"
          visible={this.state.questionIDParams? 'true' : 'false'}
          fullPage
          focusOnMount={false}
          onShow={this.handleShow}
          onHide={this.hide}
          closeOnEsc={false}
        >
          <div>
            {' '}
            <Button icon onClick={this.hide}>
              close
            </Button>
          </div>
          <div style={{ overflow: 'hidden' }}>
            <CreateQuestion
              selectedSubjectId={this.state.subjectIdParams}
              selectedTopicId={this.state.topicIdParams}
              selectedCategoryId={this.state.categoryIdParams}
              selectedSubCategoryId={this.state.subCategoryIdParams}
              selectedQuestionId={this.state.questionIDParams}
              hidemodule={this.hide}
              selectedIndex={this.state.selectedIndex}
              copyMode={this.state.copyMode}
              moveMode={this.state.moveMode} //Adding Move Option
              setRedirectURL={this.setRedirectURL.bind(this)}
              close={this.hide}
              readOnly={this.props.readOnly}
              currSubject={this.state.currSubject}
            />
          </div>
          <div />
        </DialogContainer>
        </div> : ''}
        <br/>
        <center>

          {!this.appProperties.enableLTI  ? 
          
            <div style={this.state.currSubject ? {display:"none"}:{width:"35%"}}className='image-resize-warning'>
            <p><b>Note :</b> Contact Administrator to gain access to edit this page.</p>
            </div> : " "
        }
        {
                this.appProperties.enableLTI  ? 
                <div style={{width:"35%",marginTop:"10px"}} className='image-resize-warning'>
                <p><b>Note :</b> No one can make any changes in the LTI version. Please go to the OSU core question bank to make changes</p>
                </div> : " "
        }
        </center>

        <DuplicateQuestionAndLink
          open={this.state.duplicateLinkDialogOpen}
          onClose={this.handleDuplicateLinkDialogClose}
          questionData={this.state.duplicateLinkQuestionData}
        />
        <BulkDuplicateDialog
          visible={this.state.bulkDuplicateDialogVisible}
          onHide={() => this.setState({ bulkDuplicateDialogVisible: false, duplicateQuestions: [], isSingleDuplication: false })}
          selectedQuestions={this.state.duplicateQuestions}
          currentSubjectId={parseInt(this.props.subject_id, 10)}
          currentTopicId={parseInt(this.props.topic_id, 10)}
          currentCategoryId={parseInt(this.props.category_id, 10)}
          currentSubCategoryId={parseInt(this.props.subcategory_id, 10)}
          isSingleDuplication={this.state.isSingleDuplication}
          onSuccess={(destSubjectId, destTopicId, destCategoryId, destSubCategoryId) => {
            this.setState({
              bulkDuplicateDialogVisible: false,
              duplicateQuestions: [],
              isSingleDuplication: false,
            })
            if (
              destSubjectId === parseInt(this.props.subject_id, 10) &&
              destTopicId === parseInt(this.props.topic_id, 10) &&
              destCategoryId === parseInt(this.props.category_id, 10) &&
              destSubCategoryId === parseInt(this.props.subcategory_id, 10)
            ) {
              this._refresh();
            }
          }}
        />

      </div>

    );
  }

   //Archive Restore
   onArchiveRestoreClick = (object) => {
    let payload = {
      subject_id:object.subject_id,
      topic_id:object.topic_id,
      category_id:object.category_id,
      subcategory_id:object.subcategory_id?object.subcategory_id:0,
      question_id:object.question_id,
    };
    restoreQuestionBankHandler(payload);
  }
}
